import React from 'react'
import { useIntl } from 'react-intl'
import { useRecoilValue } from 'recoil'

import {
  Panel,
  Text,
  TEXT_VARIANT_BOLD,
  TEXT_VARIANT_LIGHT,
  SpacingVertical,
  SPACING_8
} from 'mailup-web-components'

import { abTestState } from '../recoil/state/abTest'

const AbTestWinnerStartDate = () => {
  const intl = useIntl()
  const { Info } = useRecoilValue(abTestState)

  return (
    <>
      {Info.WinnerDateCTZScheduled !== null && (
        <Panel collapsible={false}>
          <Text variant={TEXT_VARIANT_BOLD}>
            {intl.formatMessage({ id: 'Load.AbTest.TimeSendWinnerAutoABTest' })}
          </Text>
          <SpacingVertical variant={SPACING_8} />
          <Text variant={TEXT_VARIANT_LIGHT}>
            {
              Info.WinnerDateCTZScheduled.replace('T', ' ')
                .replace('Z', ' ')
                .split('.')[0]
            }
            {Info.TimeZoneScheduled.split('.')[0]}
          </Text>
        </Panel>
      )}
    </>
  )
}

export default AbTestWinnerStartDate
